// https://github.com/Automattic/node-canvas/blob/master/browser.js

import { isNode } from "./main.js"


export { SKRSContext2D as CanvasRenderingContext2D, createCanvas, loadImage }
export type Image = SKRSImage & HTMLImageElement

const createCanvas = isNode ? node_createCanvas :
	(width: number, height: number) => {
		return Object.assign(globalThis.document.createElement("canvas"), { width: width, height: height }) as unknown as Canvas
	}

const loadImage = isNode ? (node_loadImage as (...args: Parameters<typeof node_loadImage>) => Promise<Image>)
	: (src: string | Buffer, options?: Record<string, any>): Promise<Image> => {
		return new Promise((resolve, reject) => {
			const image = Object.assign(globalThis.document.createElement("img"), options) as Image,
				cleanup = () => image.onload = image.onerror = null

			image.onload = () => { cleanup(); resolve(image) }
			image.onerror = () => { cleanup(); reject(new Error(`Failed to load the image "${src}"`)) }

			image.src = src as string
		})
	}

